/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import clsx from 'clsx';
import { Typography as AntTypography } from 'antd';

import Title from './Title';

import s from './styles.module.less';

const Note = ({ as: Component = 'span', className, ...props }) => (
  <Component className={clsx(s.note, className)} {...props} />
);

const Typography = (props) => <AntTypography {...props} />;

Typography.Paragraph = AntTypography.Paragraph;
Typography.Note = Note;
Typography.Text = AntTypography.Text;
Typography.Title = Title;

export default Typography;
